// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__37m9o"};